"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyTransactionWrapper$ = exports.PropertyTransactionWrapper$outboundSchema = exports.PropertyTransactionWrapper$inboundSchema = void 0;
exports.propertyTransactionWrapperToJSON = propertyTransactionWrapperToJSON;
exports.propertyTransactionWrapperFromJSON = propertyTransactionWrapperFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const saletransactionattributes_js_1 = require("./saletransactionattributes.js");
/** @internal */
exports.PropertyTransactionWrapper$inboundSchema = z.object({
    attributes: saletransactionattributes_js_1.SaleTransactionAttributes$inboundSchema,
    id: z.string(),
    type: z.literal("property_transaction").default("property_transaction")
        .optional(),
});
/** @internal */
exports.PropertyTransactionWrapper$outboundSchema = z.object({
    attributes: saletransactionattributes_js_1.SaleTransactionAttributes$outboundSchema,
    id: z.string(),
    type: z.literal("property_transaction").default("property_transaction"),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PropertyTransactionWrapper$;
(function (PropertyTransactionWrapper$) {
    /** @deprecated use `PropertyTransactionWrapper$inboundSchema` instead. */
    PropertyTransactionWrapper$.inboundSchema = exports.PropertyTransactionWrapper$inboundSchema;
    /** @deprecated use `PropertyTransactionWrapper$outboundSchema` instead. */
    PropertyTransactionWrapper$.outboundSchema = exports.PropertyTransactionWrapper$outboundSchema;
})(PropertyTransactionWrapper$ || (exports.PropertyTransactionWrapper$ = PropertyTransactionWrapper$ = {}));
function propertyTransactionWrapperToJSON(propertyTransactionWrapper) {
    return JSON.stringify(exports.PropertyTransactionWrapper$outboundSchema.parse(propertyTransactionWrapper));
}
function propertyTransactionWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PropertyTransactionWrapper$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PropertyTransactionWrapper' from JSON`);
}
//# sourceMappingURL=propertytransactionwrapper.js.map